import { render, staticRenderFns } from "./BaseCardBody.vue?vue&type=template&id=761c8928"
import script from "./BaseCardBody.vue?vue&type=script&lang=js"
export * from "./BaseCardBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports